

//import {Gatekeeper} from 'gatekeeper-client-sdk';
import axios from '@app/services/axios';
import {LOGIN_METHOD, verify_token_METHOD} from '@app/const/AppSetting';
import { setAuthToken, setAuthProfile } from './tokenManager';

export const loginByAuth = async (email, password) => {
    try {
        console.log('AuthService: loginByAuth called for:', email);

        const loginData = {
            Username: email,
            Password: password,
            isAndroid: 1,
        };

        const response = await axios.post(LOGIN_METHOD, loginData);
        console.log('AuthService: Login response received');

        if (response.data.flag) {
            const token = response.data.accessToken;

            // Store authentication data
            localStorage.setItem('token', token);
            localStorage.setItem('profile', JSON.stringify(response.data));


            // Clean up DOM classes
            const rootElement = document.getElementById('root');
            if (rootElement) {
                rootElement.classList.remove('login-page');
                rootElement.classList.remove('hold-transition');
            }

            console.log('AuthService: Login successful, token stored');
        } else {
            console.log('AuthService: Login failed:', response.data.msg);
        }

        return response.data;
    } catch (error) {
        console.error('AuthService: Login error:', error);
        throw error;
    }
};

export const verify_token = async () => {
    try {
        console.log('AuthService: verify_token called');

        // Check if token exists first
        const token = localStorage.getItem('token');
        if (!token) {
            console.log('AuthService: No token found in localStorage');
            return { flag: false, msg: 'No authentication token found' };
        }

        console.log('AuthService: Verifying token with server...');
        const response = await axios.post(verify_token_METHOD, {});

        if (response && response.data) {
            console.log('AuthService: Token verification response:', response.data.flag ? 'valid' : 'invalid');
            return response.data;
        } else {
            console.error('AuthService: Invalid response from token verification');
            return { flag: false, msg: 'Invalid server response' };
        }
    } catch (error) {
        console.error('AuthService: Token verification error:', error);

        // Don't clear localStorage here - let the calling component decide
        if (error.response?.status === 401) {
            return { flag: false, msg: 'Token expired or invalid' };
        } else if (error.code === 'ERR_NETWORK' || !navigator.onLine) {
            return { flag: false, msg: 'Network connection error' };
        } else {
            return { flag: false, msg: 'Server connection failed' };
        }
    }
};

export const logout = () => {
    console.log('AuthService: Logging out user');

    // Clear all authentication data
    localStorage.removeItem('token');
    localStorage.removeItem('profile');

    // Clean up DOM classes
    const rootElement = document.getElementById('root');
    if (rootElement) {
        rootElement.classList.remove('sidebar-mini');
        rootElement.classList.remove('layout-fixed');
        rootElement.classList.add('login-page');
        rootElement.classList.add('hold-transition');
    }
};

export const registerByAuth = async (email, password) => {
    // Implementation when needed
    console.log('AuthService: registerByAuth not implemented');
    return null;
};

export const loginByGoogle = async () => {
    // Implementation when needed
    console.log('AuthService: loginByGoogle not implemented');
    return null;
};

export const registerByGoogle = async () => {
    // Implementation when needed
    console.log('AuthService: registerByGoogle not implemented');
    return null;
};

export const loginByFacebook = async () => {
    // Implementation when needed
    console.log('AuthService: loginByFacebook not implemented');
    return null;
};

export const registerByFacebook = async () => {
    // Implementation when needed
    console.log('AuthService: registerByFacebook not implemented');
    return null;
};

// Helper function to check if user is authenticated
export const isAuthenticated = () => {
    const token = localStorage.getItem('token');
    const profile = localStorage.getItem('profile');
    return !!(token && profile);
};

// Helper function to get current user profile
export const getCurrentUser = () => {
    try {
        const profile = localStorage.getItem('profile');
        return profile ? JSON.parse(profile) : null;
    } catch (error) {
        console.error('AuthService: Error parsing profile from localStorage:', error);
        return null;
    }
};